import React from "react";

const masterRoutes = [
    //country
    {
        path: "/master/country/list",
        component: React.lazy(() => import("./country/CountryList")),
    },

    {
        path: "/master/country/:viewType/:ctryCode",
        component: React.lazy(() => import("./country/CountryFormDetails")),
    },

    //currency
    {
        path: "/master/currency/list",
        component: React.lazy(() => import("./currency/CurrencyList")),
    },
    {
        path: "/master/currency/:viewType/:ccyCode?",
        component: React.lazy(() => import("./currency/CurrencyFormDetails")),
    },

    //contract
    {
        path: "/master/contract/list",
        component: React.lazy(() => import("./contract/ContractList")),
    },
    {
        path: "/master/contract/:viewType/:radio?",
        component: React.lazy(() => import("./contract/ContractFormDetails")),
    },
    //harmonized
    {
        path: "/master/hsCode/list",
        component: React.lazy(() => import("./hsCode/HsCodeList")),
    },
    {
        path: "/master/hsCode/:viewType/:hsCode?",
        component: React.lazy(() => import("./hsCode/HsCodeFormDetails")),
    },

    //for port
    {
        path: "/master/port/list",
        component: React.lazy(() => import("./port/PortList")),
    },
    {
        path: "/master/port/:viewType/:portCode?",
        component: React.lazy(() => import("./port/PortFormDetails")),
    },

    //for UOM
    {
        path: "/master/uom/list",
        component: React.lazy(() => import("./uom/UOMCodesList")),
    },
    {
        path: "/master/uom/:viewType/:uomCode",
        component: React.lazy(() => import("./uom/UOMCodeFormDetails")),
    },

    //for Ministry
    {
        path: "/master/ministry/list",
        component: React.lazy(() => import("./ministry/MinistryList")),
    },
    {
        path: "/master/ministry/:viewType/:id?",
        component: React.lazy(() => import("./ministry/MinistryFormDetails")),
    },

    //for Agency
    {
        path: "/master/agency/list",
        component: React.lazy(() => import("./agency/AgencyList")),
    },
    {
        path: "/master/agency/:viewType/:id?",
        component: React.lazy(() => import("./agency/AgencyFormDetails")),
    },

    //for Agency Office
    {
        path: "/master/agencyoffice/list",
        component: React.lazy(() => import("./agencyoffice/AgencyOfficeList")),
    },
    {
        path: "/master/agencyoffice/:viewType/:id?",
        component: React.lazy(() => import("./agencyoffice/AgencyOfficeFormDetails")),
    },

    //for Ship Types and Extra Fields
    {
        path: "/master/shipTypeEF/list",
        component: React.lazy(() => import("./shipTypeEF/ShipTypeEFList")),
    },
    {
        path: "/master/shipTypeEF/:viewType/:shipType?",
        component: React.lazy(() => import("./shipTypeEF/ShipTypeEFFormDetails")),
    },

    {
        path: "/master/attachType/list",
        component: React.lazy(() => {
            return import("./attachType/AttachTypeList");
        }),
    },
    {
        path: "/master/attachType/:viewType/:id?",
        component: React.lazy(() => {
            return import("./attachType/AttachTypeFormDetails");
        }),
    },
    {
        path: "/master/docAssociate/list",
        component: React.lazy(() => {
            return import("./docAssociate/DocAssociateList");
        }),
    },
    {
        path: "/master/docAssociate/:viewType/:id?",
        component: React.lazy(() => {
            return import("./docAssociate/DocAssociateFormDetails");
        }),
    },

    //Ship Type Master Data
    {
        path: "/master/shipType/list",
        component: React.lazy(() => import("./shipType/ShipTypeList")),
    },
    {
        path: "/master/shipType/:viewType/:stCode?",
        component: React.lazy(() => import("./shipType/ShipTypeFormDetails")),
    },

    //Thruster Type Master Data
    {
        path: "/master/thrusterType/list",
        component: React.lazy(() => import("./thrusterType/ThrusterTypeList")),
    },
    {
        path: "/master/thrusterType/:viewType/:ttCode?",
        component: React.lazy(() => import("./thrusterType/ThrusterTypeFormDetails")),
    },

    //Office Code Master Data
    {
        path: "/master/officeCode/list",
        component: React.lazy(() => import("./officeCodes/OfficeCodesList")),
    },
    {
        path: "/master/officeCode/:viewType/:ocId?",
        component: React.lazy(() => import("./officeCodes/OfficeCodesFormDetails")),
    },

    // Clearance Flag Master Data
    {
        path: "/master/clearanceFlag/list",
        component: React.lazy(() => import("./clearanceFlag/ClearanceFlagCodesList")),
    },
    {
        path: "/master/clearanceFlag/:viewType/:cfId?",
        component: React.lazy(() => import("./clearanceFlag/ClearanceFlagFormDetails")),
    },

    // Payment Type Master Data
    {
        path: "/master/paymentType/list",
        component: React.lazy(() => import("./paymentType/PaymentTypeList")),
    },
    {
        path: "/master/paymentType/:viewType/:ptCode?",
        component: React.lazy(() => import("./paymentType/PaymentTypeFormDetails")),
    },

    //Fee Config
    {
        path: "/master/feeConfig/list",
        component: React.lazy(() => import("./feeConfig/FeeConfigList")),
    },
    {
        path: "/master/feeConfig/:viewType/:id?",
        component: React.lazy(() => import("./feeConfig/FeeConfigFormDetails")),
    },

    // Province
    {
        path: "/master/province/list",
        component: React.lazy(() => import("./province/ProvinceList")),
    },
    {
        path: "/master/province/:viewType/:provinceId?",
        component: React.lazy(() => import("./province/ProvinceFormDetails")),
    },

    // Number Engine
    {
        path: "/master/numberEngine/list",
        component: React.lazy(() => import("./numberEngine/NumberEngineList")),
    },
    {
        path: "/master/numberEngine/:viewType/:neCode?",
        component: React.lazy(() => import("./numberEngine/NumberEngineFormDetails")),
    },

    // Article Category
    {
        path: "/master/articleCategory/list",
        component: React.lazy(() => import("./articleCategory/ArticleCategoryList")),
    },
    {
        path: "/master/articleCategory/:viewType/:arcCode?",
        component: React.lazy(() => import("./articleCategory/ArticleCategoryFormDetails")),
    },

    // Crew Rank
    {
        path: "/master/crewRank/list",
        component: React.lazy(() => import("./crewRank/CrewRankList")),
    },
    {
        path: "/master/crewRank/:viewType/:crewRankId?",
        component: React.lazy(() => import("./crewRank/CrewRankFormDetails")),
    },

    // Port Terminal
    {
        path: "/master/portTerminal/list",
        component: React.lazy(() => import("./portTerminal/PortTerminalList")),
    },
    {
        path: "/master/portTerminal/:viewType/:portTeminalId?",
        component: React.lazy(() => import("./portTerminal/PortTerminalFormDetails")),
    },

    // DOS Activity
    {
        path: "/master/dosActivity/list",
        component: React.lazy(() => import("./dosActivity/DosActivityList")),
    },
    {
        path: "/master/dosActivity/:viewType/:dosActivityId?",
        component: React.lazy(() => import("./dosActivity/DosActivityFormDetails")),
    },

    // Areas Inspected
    {
        path: "/master/areasInspected/list",
        component: React.lazy(() => import("./areasInspected/AreasInspectedList")),
    },
    {
        path: "/master/areasInspected/:viewType/:areasInspectedId?",
        component: React.lazy(() => import("./areasInspected/AreasInspectedFormDetails")),
    },

    // Notification Template
    {
        path: "/notification/templates/list",
        component: React.lazy(() => import("../../notification/notificationTemplate/NotificationTemplateList")),
    },
    {
        path: "/notification/templates/:viewType/:ntplId?",
        component: React.lazy(() => import("../../notification/notificationTemplate/NotificationTemplateFormDetails")),
    },

    // Certificate Config
    {
        path: "/master/certificateConfig/list",
        component: React.lazy(() => import("./certificateConfig/CertificateConfigList")),
    },
    {
        path: "/master/certificateConfig/:viewType/:id",
        component: React.lazy(() => import("./certificateConfig/CertificateConfigFormDetails")),
    },

    // Certificate Svc
    {
        path: "/master/certificateSvc/list",
        component: React.lazy(() => import("./certificateSvc/CertificateSvcList")),
    },
    {
        path: "/master/certificateSvc/:viewType/:id?",
        component: React.lazy(() => import("./certificateSvc/CertificateSvcFormDetails")),
    },

    // Duty Paid At
    {
        path: "/master/dutyPaidAt/list",
        component: React.lazy(() => import("./dutyPaidAt/DutyPaidAtList")),
    },
    {
        path: "/master/dutyPaidAt/:viewType/:dutyPaidId?",
        component: React.lazy(() => import("./dutyPaidAt/DutyPaidAtFormDetails")),
    },

    // Amendment Applications
    {
        path: "/master/amendmentApplications/list",
        component: React.lazy(() => import("./amendmentApplications/AmendmentApplicationsList")),
    },
    {
        path: "/master/amendmentApplications/:viewType/:ammID?",
        component: React.lazy(() => import("./amendmentApplications/AmendmentApplicationsFormDetails")),
    },

    // Amendment Fields
    {
        path: "/master/amendmentFields/list",
        component: React.lazy(() => import("./amendmentFields/AmendmentFieldsList")),
    },
    {
        path: "/master/amendmentFields/:viewType/:amfID?",
        component: React.lazy(() => import("./amendmentFields/AmendmentFieldsFormDetails")),
    },

    // FAQ Information
    {
        path: "/master/faq/list",
        component: React.lazy(() => import("./FAQInformation/FAQList")),
    },
    {
        path: "/master/faq/:viewType/:faqID?",
        component: React.lazy(() => import("./FAQInformation/FAQFormDetails")),
    },
];

export default masterRoutes;
